import { useContext, useEffect, useState } from "react";
import styles from "./reclamosReconexiones.module.css";
import ApiFetch from "../../utils/fetch";
import ModalReclamo from "./modalReclamo/modalReclamo";
import ModalReconexion from "./modalReconexion/modalReconexion";
import { Alert } from "react-bootstrap";
import Loading from "../../components/loading/loading";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import PhoneIcon from "@mui/icons-material/Phone";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import WifiIcon from "@mui/icons-material/Wifi";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SwalAlert from "../../utils/swalAlert";
import TitlePage from "../../components/titlePage/titlePage";
import { AppContext } from "../../context/context";
import UpdateProfile from "../../components/updateProfile/updateProfile";
import TabsMui from "../../components/tab/tabs";
import { TabPanel } from "@mui/lab";
import ModalMisReclamo from "./modalMisReclamos/modalMisReclamos";
import BotonSwal from "./modalMisReclamos/swalAlertCancelar";
import Btn from "../../components/btn/btn";
import Swal from "sweetalert2";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";

const fetch = new ApiFetch();
const alert = new SwalAlert();

const ReclamosReconexiones = () => {
  const { sessionExpired } = useContext(AppContext);
  const [services, setServices] = useState([]);
  const [misReclamos, setMisReclamos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reclamos, setReclamos] = useState([]);

  const getServices = async () => {
    try {
      setLoading(<Loading />);
      const data = await fetch.GET("/services");
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      if (status === 401) {
        sessionExpired(message);
        return;
      }
      setServices(Array.isArray(data?.body) ? data.body : []);
    } catch (error) {
      //Un error de red no es una sesión vencida: no se borra la sesión.
      setLoading("");
      setServices([]);
      alert.error("No fue posible obtener sus servicios.");
    }
  };

  const getMisReclamos = async () => {
    try {
      setLoading(<Loading />);
      const data = await fetch.GET("/reclamos/getReclamosAsociado");
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      if (status === 401) {
        sessionExpired(message);
        return;
      }
      setMisReclamos(Array.isArray(data?.body) ? data.body : []);
    } catch (error) {
      setLoading("");
      alert.error("No fue posible obtener sus reclamos");
    }
  };

  const recargaReclamos = async () => {
    const data = await fetch.GET("/reclamos/getReclamosAsociado");
    setMisReclamos(data?.body || []);
  };

  async function solicitarPackFutbol(idPrestacionIptv) {
    try {
      setLoading(<Loading />);
      const data = await fetch.POST(
        JSON.stringify({ idPrestacion: idPrestacionIptv }),
        "/serviciosCoop/iptv/addPackFutbol",
      );
      setLoading("");

      if (data?.status !== 201) {
        alert.error(
          data?.message || "No fue posible solicitar el Pack Futbol.",
        );
        return;
      }

      alert.success(data?.message || "Pack Fútbol solicitado exitosamente.");
      await getServices();
    } catch (error) {
      setLoading("");
      alert.error("Servicio no disponible. Intente nuevamente más tarde.");
    }
  }

  const confirmSolicitarPackFutbol = (idPrestacionIptv) => {
    Swal.fire({
      text: "¿Desea solicitar el Pack Fútbol?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#229954",
      cancelButtonColor: "grey",
      confirmButtonText: "Solicitar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await solicitarPackFutbol(idPrestacionIptv);
      }
    });
  };

  useEffect(() => {
    getServices();
    getMisReclamos();
  }, []);

  return (
    <div className={styles.container}>
      <ReturnBackButton />
      <TitlePage idTramite={2} />
      <Alert variant="info" className={styles.alertTitle}>
        ¡ Consultá el estado de tus servicios !<br></br>
        Ahora también podés solicitar el pack fútbol para tu servicio de TV
        desde esta sección.
      </Alert>
      <div className={styles.tableClientContainer}>
        <TabsMui
          tabs={[
            { label: "Mis Servicios", value: "1" },
            { label: "Mis Reclamos", value: "2" },
          ]}
        >
          <TabPanel value="1">
            <div className={styles.tableContainer}>
              {services?.length > 0 ? (
                <table className={styles.tableServices}>
                  <thead>
                    <tr>
                      <th>Servicio</th>
                      <th>Domicilio</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  {services?.map((service, i) => {
                    const infoMessage = service?.infoMessage;
                    let colorInfoMessage;
                    const idService = service?.IdServicio;
                    let icon;
                    switch (idService) {
                      case 1:
                        icon = (
                          <ElectricBoltIcon
                            style={{ color: "#F1C40F", marginRight: 5 }}
                          />
                        );
                        break;
                      case 2:
                        icon = (
                          <WaterDropIcon
                            style={{ color: "#5DADE2", marginRight: 5 }}
                          />
                        );
                        break;
                      case 3:
                        icon = (
                          <PhoneIcon
                            style={{ color: "#CA6F1E", marginRight: 5 }}
                          />
                        );
                        break;
                      case 5:
                        icon = (
                          <WifiIcon
                            style={{ color: "#5D6D7E", marginRight: 5 }}
                          />
                        );
                        break;
                      case 30:
                        icon = (
                          <LiveTvIcon
                            style={{ color: "#17A589", marginRight: 5 }}
                          />
                        );
                        break;

                      default:
                        break;
                    }

                    switch (infoMessage?.type) {
                      case "succces":
                        colorInfoMessage = "#229954";
                        break;
                      case "error":
                        colorInfoMessage = "#CB4335";
                        break;
                      case "warning":
                        colorInfoMessage = "#CA6F1E";
                        break;
                      case "info":
                        colorInfoMessage = "#2980B9";
                        break;
                    }

                    return (
                      <tbody
                        key={i}
                        style={{ fontSize: 12, wordWrap: "break-word" }}
                      >
                        <tr>
                          <td>
                            {icon}
                            {service?.Servicio}
                          </td>
                          <td>{service?.Domicilio}</td>
                          <td
                            style={{
                              color:
                                service?.IdEstadoPrest === 1
                                  ? "#229954"
                                  : "#CB4335",
                              fontWeight: "bold",
                            }}
                          >
                            {service?.Estado}
                          </td>
                          <td>
                            <div className={styles.buttonContainer}>
                              {service?.reclamo && (
                                <ModalReclamo
                                  service={service?.Servicio}
                                  idPrestacion={service?.IdPrestacion}
                                  onReclamoCreado={recargaReclamos}
                                />
                              )}
                              {service?.reconectar && (
                                <ModalReconexion
                                  getServices={() => getServices()}
                                  servicio={service?.Servicio}
                                  idServicio={service?.IdServicio}
                                  idPrestacion={service?.IdPrestacion}
                                />
                              )}
                              {infoMessage && (
                                <>
                                  {service?.infoMessage?.type ===
                                  "reconexion" ? (
                                    <div className={styles.loader}></div>
                                  ) : (
                                    <span style={{ color: colorInfoMessage }}>
                                      {infoMessage?.message}
                                    </span>
                                  )}
                                </>
                              )}
                              {service?.solicitarPackFutbol && (
                                <Btn
                                  action={() =>
                                    confirmSolicitarPackFutbol(
                                      service?.IdPrestacion,
                                    )
                                  }
                                  text="Solicitar Pack Futbol"
                                  color="success"
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              ) : (
                "No se encontraron servicios."
              )}
            </div>
          </TabPanel>

          <TabPanel value="2">
            <div className={styles.tableContainer}>
              {misReclamos?.length > 0 ? (
                <table className={styles.tableServices}>
                  <thead>
                    <tr>
                      <th>Servicio</th>
                      <th>Domicilio</th>
                      <th>Fecha Inicio</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  {misReclamos?.map((misReclamos, i) => {
                    const infoMessage = misReclamos?.infoMessage;
                    let colorInfoMessage;
                    const idService = misReclamos?.IdServicio;
                    let icon;
                    const fecInicio =
                      misReclamos?.FecInicio; /**Constante de Fecha */
                    const estadoReclamo =
                      misReclamos?.DsTipoEstTr; /**Estado de Tramite */

                    switch (idService) {
                      case 1:
                        icon = (
                          <ElectricBoltIcon
                            style={{ color: "#F1C40F", marginRight: 5 }}
                          />
                        );
                        break;
                      case 2:
                        icon = (
                          <WaterDropIcon
                            style={{ color: "#5DADE2", marginRight: 5 }}
                          />
                        );
                        break;
                      case 3:
                        icon = (
                          <PhoneIcon
                            style={{ color: "#CA6F1E", marginRight: 5 }}
                          />
                        );
                        break;
                      case 5:
                        icon = (
                          <WifiIcon
                            style={{ color: "#5D6D7E", marginRight: 5 }}
                          />
                        );
                        break;
                      case 30:
                        icon = (
                          <LiveTvIcon
                            style={{ color: "#17A589", marginRight: 5 }}
                          />
                        );
                        break;

                      default:
                        break;
                    }

                    switch (infoMessage?.type) {
                      case "succces":
                        colorInfoMessage = "#229954";
                        break;
                      case "error":
                        colorInfoMessage = "#CB4335";
                        break;
                      case "warning":
                        colorInfoMessage = "#CA6F1E";
                        break;
                      case "info":
                        colorInfoMessage = "#2980B9";
                        break;
                    }

                    return (
                      <tbody
                        key={i}
                        style={{ fontSize: 12, wordWrap: "break-word" }}
                      >
                        <tr>
                          <td>
                            {icon}
                            {misReclamos?.DsServicio}
                          </td>
                          <td>{misReclamos?.Domicilio}</td>
                          <td>{misReclamos?.FecInicio}</td>
                          <td
                            style={{
                              color:
                                misReclamos?.IdTipoEstTr === 2
                                  ? "#229954"
                                  : "#CB4335",
                              fontWeight: "bold",
                            }}
                          >
                            {estadoReclamo}
                          </td>
                          <td>
                            <div className={styles.buttonContainer}>
                              <BotonSwal
                                reclamo={misReclamos}
                                onUpdate={recargaReclamos}
                              />
                            </div>
                          </td>
                          <td>
                            <div className={styles.buttonContainer}>
                              <ModalMisReclamo reclamo={misReclamos} />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              ) : (
                "No se encontraron reclamos."
              )}
            </div>
          </TabPanel>
        </TabsMui>
      </div>
      {/* <UpdateProfile /> */}
      {loading}
    </div>
  );
};

export default ReclamosReconexiones;
